import calculadora from '../../images/banner2.png'
import eduskill from "../../images/banner.png";
import quotemachine from "../../images/banner3.png";
import fronteam from '../../images/banner4.png';
import dato from '../../images/dato.png'
import ing from '../../images/ingeniero.png'

export const data = {
         //proyects
         proyects: [
           {
             img: calculadora,
             ref: "https://ecstatic-joliot-a26994.netlify.app/",
           },
           {
             img: eduskill,
             ref: "https://eduskill.netlify.app/",
           },
           {
             img: quotemachine,
             ref: "https://quote-machine-iota.now.sh/",
           },
           {
             img: fronteam,
             ref: "https://dinareales.github.io/front2_TeamFrontend/",
           },
         ],
         //Estudios

         studies: [
           {
             img: dato,
             name: "Desarrolladora Front-End",
             nameAcademia: "Academia Geek",
             ref:
               "https://drive.google.com/file/d/1Adv4hkZe3H-aio6eniBYYnSD3ed2Z0jp/view?usp=sharing",
             typeStudy: "Bootcamp",
           },
           {
             img: ing,
             name: "Ingeniera Industrial",
             nameAcademia: "Universidad de Boyacá",
             ref:
               "https://drive.google.com/file/d/0BzW4AD7o1xEQRXROaFdWSVZzUms/view?usp=sharing",
             typeStudy: "Profesional",
           },
         ],

         //contacto
         contacto: [
           {
             icon: "https://img.icons8.com/cute-clipart/80/000000/github.png",
             ref: "https://github.com/yeraldith",
           },
           {
             icon: "https://img.icons8.com/color/96/000000/linkedin.png",
             ref:
               "https://www.linkedin.com/in/yeraldith-camargo-ayala-74130610a/ ",
           },
           {
             icon: "https://img.icons8.com/color/96/000000/twitter-squared.png",
             ref: "https://twitter.com/Yeraldith15",
           },
           {
             icon: "https://img.icons8.com/color/48/000000/browse-folder.png",
             ref:
               "https://drive.google.com/file/d/1Gje8p-yiAnByDGzfSmJBv6vFEWF2Wxn-/view?usp=sharing",
           },
         ],
       };



